import FIDESConfigurer from './FIDESConfigurer';

export default FIDESConfigurer;
